const applicationDataHash = {
  ach_origination: 'ProgramBalance',
  three_ds: 'ThreeDS',
  direct_deposit: 'DirectDeposit',
};

export default applicationDataHash;
